import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1c918ee9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "h-button__label"
}

import { computed, useSlots } from "vue";
import { useI18n } from "vue-i18n";
import type { SizeType } from "ant-design-vue/es/config-provider";

type ButtonType = "primary" | "default" | "dashed" | "link" | "text";
type ButtonShape = "default" | "circle" | "round";
type HtmlType = "button" | "submit" | "reset";

interface Props {
  /** Text hiển thị. Có thể truyền sẵn $t(...) hoặc key nếu bật i18n */
  label?: string;
  /** true → gọi $t(label) */
  i18n?: boolean;
  icon?: string;
  iconRight?: string;
  type?: ButtonType;
  size?: SizeType;
  danger?: boolean;
  ghost?: boolean;
  loading?: boolean;
  disabled?: boolean;
  block?: boolean;
  htmlType?: HtmlType;
  shape?: ButtonShape;
  href?: string;
  target?: string;
  /** Class bổ sung */
  classBtn?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Primary',
  props: {
    label: { default: "" },
    i18n: { type: Boolean, default: false },
    icon: { default: "" },
    iconRight: { default: "" },
    type: { default: "default" },
    size: { default: "middle" },
    danger: { type: Boolean, default: false },
    ghost: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    htmlType: { default: "button" },
    shape: { default: "default" },
    href: { default: undefined },
    target: { default: undefined },
    classBtn: { default: "" }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const slots = useSlots();
const { t } = useI18n();

const displayLabel = computed(() => {
  if (!props.label) return "";
  return props.i18n ? t(props.label) : props.label;
});

const isIconOnly = computed(() => {
  const hasLabel = !!displayLabel.value || !!slots.default;
  return !!props.icon && !hasLabel && !props.iconRight;
});

const buttonClass = computed(() => [
  "h-button",
  props.classBtn,
  {
    "h-button--icon-only": isIconOnly.value,
    "h-button--with-right-icon": !!props.iconRight,
  },
]);

const onClick = (event: MouseEvent) => {
  if (props.disabled || props.loading) return;
  emit("click", event);
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_component_a_button, {
    type: _ctx.type,
    size: _ctx.size,
    danger: _ctx.danger,
    ghost: _ctx.ghost,
    loading: _ctx.loading,
    disabled: _ctx.disabled,
    block: _ctx.block,
    "html-type": _ctx.htmlType,
    shape: _ctx.shape,
    href: _ctx.href,
    target: _ctx.target,
    class: _normalizeClass(buttonClass.value),
    onClick: onClick
  }, _createSlots({
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        (displayLabel.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(displayLabel.value), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.iconRight && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(["h-button__icon-right", _ctx.iconRight]),
            "aria-hidden": "true"
          }, null, 2))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_ctx.icon && !_ctx.loading)
      ? {
          name: "icon",
          fn: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.icon),
              "aria-hidden": "true"
            }, null, 2)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["type", "size", "danger", "ghost", "loading", "disabled", "block", "html-type", "shape", "href", "target", "class"]))
}
}

})